module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isActive),
      expression: "isActive"
    }],
    staticClass: "aside",
    class: [{
      'is-active': _vm.isActive
    }, _vm.placementClass]
  }, [(_vm.backdrop) ? _c('div', {
    staticClass: "modal-background",
    on: {
      "click": _vm.backdropClose
    }
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.transitionName
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isActive),
      expression: "isActive"
    }],
    staticClass: "modal-card",
    style: (_vm.modalWidth)
  }, [(_vm.showHeader) ? _c('header', {
    staticClass: "modal-card-head aside-header"
  }, [_vm._t("header", [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('span', {
    staticClass: "close",
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("×")])])], 2) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body aside-body"
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.showFooter) ? _c('footer', {
    staticClass: "modal-card-foot aside-footer"
  }, [_vm._t("footer", [(_vm.showCancel) ? _c('a', {
    staticClass: "button",
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v(_vm._s(_vm.cancelText))]) : _vm._e(), _vm._v(" "), (_vm.showOk) ? _c('a', {
    staticClass: "button is-primary",
    class: {
      'is-loading': _vm.isLoading
    },
    on: {
      "click": _vm.handleOk
    }
  }, [_vm._v(_vm._s(_vm.okText))]) : _vm._e()])], 2) : _vm._e()])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6791bc7a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/aside/Aside.vue
// module id = 345
// module chunks = 0